import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/site';
export function TestimonialsSection() {
  return <section aria-labelledby="praise-heading" className="bg-ivory py-24 lg:py-32" data-id="element-209" data-mp="20qxf7hivkwwe">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-210" data-mp="1myz97fkgnh4g">
        <h2 id="praise-heading" className="text-center font-mono text-[11px] uppercase tracking-[0.28em] text-brass" data-id="element-211" data-mp="1r1dvk9nc8z0h">
          Designers, builders & homeowners
        </h2>
        <ul className="mt-14 grid gap-8 lg:grid-cols-3" data-id="element-212" data-mp="1i0o4fj90vwt3">
          {testimonials.map(item => <li key={item.name} className="flex flex-col border-t-2 border-brass bg-white p-8 lg:p-10" data-id="element-213" data-mp="141g0ye5tu2j3">
              <Quote className="h-6 w-6 text-brass/50" aria-hidden="true" data-id="element-214" data-mp="1839xca8zokdg" />
              <blockquote className="mt-6 flex-1 font-display text-xl leading-snug text-ink lg:text-[1.4rem]" data-id="element-215" data-mp="2yg8um7n5gj8e">
                “{item.quote}”
              </blockquote>
              <footer className="mt-8" data-id="element-216" data-mp="2v1b08w6o5uny">
                <p className="text-sm font-medium text-ink" data-id="element-217" data-mp="2v09nmna09044">{item.name}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground" data-id="element-218" data-mp="2q3116ahtq9x2">
                  {item.role}
                </p>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}